type GlubesLogoProps = {
  className?: string;
};

export default function GlubesLogo({ className }: GlubesLogoProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1732.11 340.69"
      aria-hidden
    >
      <path
        fill="currentColor"
        d="M288.52,33.13c10.41,11.02,19.43,27.25,9.4,45.68-.32.59-.61,1.2-.84,1.83-1.59,4.27-10.51,23.51-42.09,22.29-.78-.03-1.55-.13-2.31-.3-11.92-2.6-120.13-24.15-134.81,47.37-15.54,75.71,56.16,87.75,56.16,87.75,0,0,53.15,7.02,58.16-14.04,4.39-18.43-19.27-16.89-25.23-16.22-1.05.12-2.12.12-3.17-.01-8.33-1.01-42.31-7.01-43.76-37.5-.06-1.28.06-2.56.36-3.8,1.66-6.83,10-25.94,51.24-24.7,0,0,66.11,2.38,76.04.19.83-.18,1.67-.31,2.52-.34,8.23-.29,40.9,2.8,34.76,70.85-7.02,77.72-51.14,121.84-127.86,124.35-76.71,2.51-176.49-7.02-198.56-137.89,0,0-23.08-125.79,99.51-182.88,0,0,74.4-34.26,161.49-1.75,10.99,4.1,20.95,10.59,29,19.12Z"
      />
      <path
        fill="currentColor"
        d="M411.78,3.96s66.98-8.89,65.3,72.55c0,0,3.96,129.94-7.26,153.02,0,0,111.47-24.4,122.02,30.34,10.55,54.75-15.83,67.28-50.13,73.21-34.3,5.94-123.34-1.32-149.72-4.62-26.38-3.3-46.17-37.6-48.15-138.51s0-130.6,0-130.6c0,0-6.6-58.04,67.94-55.4Z"
      />
      <path
        fill="currentColor"
        d="M844.58,8.55s57.61-10.54,56.9,82.19c-.7,92.73,23.18,238.86-148.93,248.69-172.12,9.84-162.28-181.95-162.28-181.95,0,0-19.67-154.57,59.01-149.29,0,0,63.23-11.58,59.01,87.47-4.22,99.05-3.53,137.69,36.88,141.21,0,0,48.13,11.24,39.7-89.92-8.43-101.16,7.03-140.5,59.71-138.4Z"
      />
      <path
        fill="currentColor"
        d="M1124.16,162.06s65.93-12.05,55.3-79.4c0,0,1.3-74.66-116.26-78.85-10.25-.37-20.49-.93-30.72-1.69-31.47-2.33-103.96-1.47-108.94,55.02,0,0-7.8,172.97,5.67,224.02,0,0,2.13,59.88,92.87,58.65,0,0,145.33,15.08,170.85-79.21,0,0,18.43-87.2-68.76-98.54ZM1026.51,98.6c1.35-26.6,24.24-21.55,24.24-21.55,38.72-1.01,39.39,21.55,39.39,21.55,1.68,31.31-32.22,28.95-32.22,28.95-40.98,6.73-31.41-28.95-31.41-28.95ZM1093.8,229.69s-.67,22.56-39.39,21.55c0,0-22.9,5.05-24.24-21.55,0,0-9.57-35.69,31.41-28.96,0,0,33.91-2.36,32.22,28.96Z"
      />
      <path
        fill="currentColor"
        d="M1247.22,6.78s84.1-11.88,147.63,1.83c0,0,40.68,6.4,38.85,46.62-1.83,40.22-49.82,40.68-49.82,40.68l-43.39,1.37s-21.97.46-21.97,19.65,34.28,16.91,34.28,16.91l43.42.08s34.74-.54,32.45,41.05c-2.29,41.59-37.02,33.82-37.02,33.82l-61.25.57s-8.68.83-8.68,11.77,11.65,14.02,22.1,14.02h55.37s53.66-7.25,55.11,47.01-53.68,51.36-67.9,52.52l-83.28,1.74s-99.7,8.88-100.22-116.07c0,0-3.58-110.62,2.56-150.56,0,0,1.03-61.5,41.74-63.01Z"
      />
      <path
        fill="currentColor"
        d="M1601.22,2s-177.88-13.74-131.17,137.79c0,0,13.18,45.52,109.6,62.89,0,0,18.57,0,16.17,19.76,0,0-2.99,17.97-49.11-4.79,0,0-103.68-32.34-84.48,46.72,19.2,79.06,153.96,76.32,153.96,76.32,0,0,111.79-3.25,115.59-97.88,0,0,10.78-85.05-91.04-109.01l-29.95-8.39s-27.71-6.83-7.97-23.15c0,0,4.93-7.59,44.79,1.52,0,0,68.48,24.08,72.14-33.39S1662.42,3.32,1601.22,2Z"
      />
    </svg>
  );
}
